export default {"src":"/_next/static/media/mergeArrow.9c8b9691.svg","height":20,"width":19,"blurWidth":0,"blurHeight":0};